import React from 'react';
import { useAuth } from '../utils/AuthContext';
import PasswordField from './PasswordField';
import FormField from './common/FormField';
import { useForm } from './common/useForm';

const noop = () => {};

const RegisterModal = ({ onClose, onSuccess = noop }) => {
  const { register } = useAuth();
  const [form, handleChange, setForm] = useForm({
    username: '',
    password: '',
    confirmPassword: '',
    walletPin: '',
    confirmWalletPin: '',
    email: '',
    phone: ''
  });
  const [error, setError] = React.useState('');

  const submit = async (event) => {
    event.preventDefault();
    setError('');

    if (!form.username.trim() || !form.password || !form.confirmPassword || !form.walletPin || !form.confirmWalletPin || !form.email.trim() || !form.phone.trim()) {
      setError('Бүх талбарыг заавал бөглөнө үү');
      return;
    }

    if (form.password !== form.confirmPassword) {
      setError('Нууц үг давталт таарахгүй байна');
      return;
    }

    if (!/^\d{4}$/.test(form.walletPin)) {
      setError('Хэтэвчийн PIN 4 оронтой тоо байна');
      return;
    }

    if (form.walletPin !== form.confirmWalletPin) {
      setError('Хэтэвчийн PIN давталт таарахгүй байна');
      return;
    }

    try {
      await register({
        username: form.username,
        password: form.password,
        walletPin: form.walletPin,
        email: form.email,
        phone: form.phone
      });
      onClose();
      onSuccess();
    } catch (requestError) {
      const responseData = requestError.response?.data;
      const validationMessage = Array.isArray(responseData?.errors)
        ? responseData.errors.map((item) => item.message).join(', ')
        : '';
      setError(validationMessage || responseData?.message || 'Бүртгэл хийх үед алдаа гарлаа');
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" onClick={(event) => event.stopPropagation()}>
        <h3>Бүртгүүлэх</h3>
        <form className="form" onSubmit={submit}>
          <FormField
            type="input"
            label="Нэр"
            name="username"
            placeholder="Нэр"
            value={form.username}
            onChange={handleChange}
            required
          />
          <PasswordField
            placeholder="Нууц үг"
            value={form.password}
            onChange={e => handleChange({ target: { name: 'password', value: e.target.value } })}
            autoComplete="new-password"
            required
          />
          <PasswordField
            placeholder="Нууц үг давтах"
            value={form.confirmPassword}
            onChange={e => handleChange({ target: { name: 'confirmPassword', value: e.target.value } })}
            autoComplete="new-password"
            required
          />
          <FormField
            type="input"
            typeInput="password"
            inputMode="numeric"
            maxLength={4}
            pattern="[0-9]{4}"
            label="Хэтэвчийн PIN (4 оронтой)"
            name="walletPin"
            placeholder="Хэтэвчийн PIN (4 оронтой)"
            value={form.walletPin}
            onChange={e => handleChange({ target: { name: 'walletPin', value: e.target.value.replace(/\D/g, '').slice(0, 4) } })}
            autoComplete="new-password"
            required
          />
          <FormField
            type="input"
            typeInput="password"
            inputMode="numeric"
            maxLength={4}
            pattern="[0-9]{4}"
            label="Хэтэвчийн PIN давтах"
            name="confirmWalletPin"
            placeholder="Хэтэвчийн PIN давтах"
            value={form.confirmWalletPin}
            onChange={e => handleChange({ target: { name: 'confirmWalletPin', value: e.target.value.replace(/\D/g, '').slice(0, 4) } })}
            autoComplete="new-password"
            required
          />
          <FormField
            type="input"
            typeInput="email"
            label="Мэйл хаяг"
            name="email"
            placeholder="Мэйл хаяг"
            value={form.email}
            onChange={handleChange}
            required
          />
          <FormField
            type="input"
            label="Утасны дугаар"
            name="phone"
            placeholder="Утасны дугаар"
            value={form.phone}
            onChange={handleChange}
            required
          />
          {error && <p className="error">{error}</p>}
          <button type="submit">Бүртгүүлэх</button>
        </form>
      </div>
    </div>
  );
};

export default RegisterModal;
